import * as api from '@api';
import Box from '@retracedgmbh/ui-components-lib/Box';
import Preloader from '@retracedgmbh/ui-components-lib/Preloader';
import { differenceInDays, fromUnixTime } from 'date-fns';
import * as PropTypes from 'prop-types';
import { useTranslator } from '@/hooks';
import { useQuery } from '@/hooks/useApi';

const HelpDrawer = ({ articleId }) => {
  const { getTranslation } = useTranslator({ page: 'components' });
  const {
    data: response,
    isError,
    isLoading,
  } = useQuery(['article', articleId], () => api.fetchArticle(articleId), {
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
    gcTime: 1000 * 60 * 60 * 24, // 24 hours
  });
  const article = response?.data;

  const getUpdatedTime = () => {
    const updatedTime = fromUnixTime(article.updatedAt);
    const currentTime = new Date();
    const daysDiff = differenceInDays(currentTime, updatedTime);
    if (daysDiff > 7) {
      return 'updated over a week ago';
    }
    return `updated ${daysDiff} days ago`;
  };

  if (isLoading) {
    return (
      <Box flex align='center' justify='center' className='tw:h-full'>
        <Preloader
          loadingText={getTranslation('components.helpDrawer.loadingText')}
        />
      </Box>
    );
  }

  if (!article || isError) {
    return (
      <div className='tw:prose tw:prose-img:rounded-xl tw:prose-headings:underline tw:prose-a:text-blue-600 tw:p-6'>
        <h1>
          <span>{getTranslation('components.helpDrawer.error.title')}</span>
        </h1>
        <p>
          <span>
            {getTranslation('components.helpDrawer.error.description')}
          </span>{' '}
          <a href='https://help.retraced.com' target='_blank' rel='noreferrer'>
            help.retraced.com
          </a>
          <span>.</span>
        </p>
      </div>
    );
  }

  return (
    <div>
      {article && (
        <div className='tw:prose tw:prose-img:rounded-xl tw:prose-headings:underline tw:prose-a:text-blue-600 tw:p-6'>
          <h1>
            <span>{article.title}</span>
          </h1>
          <p>
            <span>{article.description}</span>
          </p>
          <p className='tw:mt-2 tw:italic'>
            <span>{getUpdatedTime()}</span>
          </p>
          <div dangerouslySetInnerHTML={{ __html: article.body }} />
        </div>
      )}
    </div>
  );
};

HelpDrawer.propTypes = {
  articleId: PropTypes.string.isRequired,
};

export default HelpDrawer;
